import { Navigate, type RouteObject } from "react-router-dom";
import { LoginPage } from "./pages/auth/LoginPage";
import { OtpPage } from "./pages/auth/OtpPage";
import { LockedPage } from "./pages/auth/LockedPage";
import { ForcePasswordPage } from "./pages/auth/ForcePasswordPage";
import { ForgotPasswordPage } from "./pages/auth/ForgotPasswordPage";
import { PublicRoute } from "./auth/PublicRoute";
import { AuthGuard } from "./auth/AuthGuard";
import { DashboardLayout } from "./pages/dashboard/DashboardLayout";
import { ConsultationsPage } from "./pages/dashboard/consultations/ConsultationsPage";
import { ConsultationWorkspacePage } from "./pages/dashboard/consultations/ConsultationWorkspacePage";
import { ReportsPage } from "./pages/dashboard/reports/ReportsPage";
import { ReportReviewPage } from "./pages/dashboard/reports/ReportReviewPage";
import { NotificationsPage } from "./pages/dashboard/notifications/NotificationsPage";

export const routes: RouteObject[] = [
  { path: "/login", element: <PublicRoute><LoginPage /></PublicRoute> },
  { path: "/login/otp", element: <PublicRoute><OtpPage /></PublicRoute> },
  { path: "/login/locked", element: <LockedPage /> },
  { path: "/login/new-password", element: <PublicRoute><ForcePasswordPage /></PublicRoute> },
  { path: "/login/forgot-password", element: <PublicRoute><ForgotPasswordPage /></PublicRoute> },
  {
    path: "/dashboard",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      { index: true, element: <Navigate to="consultations" replace /> },
      { path: "results", element: <ReportsPage /> },
      { path: "results/:id", element: <ReportReviewPage /> },
      { path: "consultations", element: <ConsultationsPage /> },
      { path: "consultations/:id", element: <ConsultationWorkspacePage /> },
      { path: "notifications", element: <NotificationsPage /> },
      { path: "*", element: <Navigate to="consultations" replace /> },
    ],
  },
  { path: "*", element: <Navigate to="/login" replace /> },
];
